import React, { useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import Preloader from "../../components/Preloader";
import Input from "../../components/Input";
import Select from "../../components/Select";
import { SaleService } from "../../services/SaleService";
import { TypesService } from "../../services/TypesService";
import { SeguimientoService } from "../../services/SeguimientoService";
import { toast } from "react-toastify";

const RegistrarWelcome = ({
    token,
    user
}) => {
    const navigate = useNavigate();
    const { id, j } = useParams();
    const [error, setError] = useState("");
    const [success, setSuccess] = useState("");
    const [loading, setLoading] = useState(false);
    const [form, setForm] = useState({
        tipoContratoActual: "",
        tipoServicio: "",
        contactabilidadValidaciones: "",
        tematicoValidaciones: "",
        numeroContactado: "",
        observacionBack: "",
    });
    const [errors, setErrors] = useState({});

    const [tematicList, setTematicList] = useState([]);
    const [contactabilidadList, setContactabilidadList] = useState([]);
    const [data, setData] = useState({});
    const [reportadas, setReportadas] = useState([]);
    const onlyRead = typeof j != "undefined" && j && j === "only";

    const handleBackToList = () => {
        navigate("/admin/bienvenida");
    };

    const handleChange = (field, value) => {
        setForm(prev => ({
            ...prev,
            [field]: value
        }));
    };

    const validateForm = () => {
        let newErrors = {};

        if (!form.tipoContratoActual.trim()) { newErrors.tipoContratoActual = "El tipo de contrato es obligatorio"; } else if (form.tipoContratoActual.length > 20) { newErrors.tipoContratoActual = "No puede tener más de 20 caracteres"; }
        if (!form.tipoServicio.trim()) {
            newErrors.tipoServicio = "El tipo de servicio es obligatorio";
        }
        if (!form.contactabilidadValidaciones.trim()) {
            newErrors.contactabilidadValidaciones = "Debe seleccionar la contactabilidad";
        }
        if (!form.tematicoValidaciones.trim()) {
            newErrors.tematicoValidaciones = "Debe seleccionar un temático";
        }
        if (!form.numeroContactado.trim()) {
            newErrors.numeroContactado = "Debe ingresar el número contactado";
        } else if (form.numeroContactado.length > 11) { newErrors.numeroContactado = "No puede tener más de 11 caracteres"; }
        if (!form.observacionBack.trim()) {
            newErrors.observacionBack = "La observación es obligatoria";
        }

        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };


    const fetchSeguimientoInstalado = async () => {
        setLoading(true);
        try {
            const responseTematic = await TypesService.get({
                token: token,
                table: 'tematico_validaciones'
            });
            const responseStatus = await TypesService.get({
                token: token,
                table: 'contactabilidad_validaciones'
            });
            setContactabilidadList(responseStatus);
            setTematicList(responseTematic);
            const responseReportadas = await SeguimientoService.getValidaciones({
                token: token,
                vid: id
            });
            setReportadas(responseReportadas);
            const responseAvance = await SaleService.fetchVentaPorId(token, id);
            setData(responseAvance.data);
            setLoading(false);
            if (responseAvance && responseAvance.data.venta.id_estado_cliente !== 2) {
                navigate("/admin/bienvenida");
                return;
            }
        } catch (error) {
            setLoading(false);
            console.error("Error al obtener la venta:", error);
        }
    };

    useEffect(() => {
        if (id) {
            fetchSeguimientoInstalado();
        }
    }, [id, token]);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        const isValid = validateForm(); if (!isValid) { setLoading(false); return; }
        try {
            const response = await SeguimientoService.createValidaciones({
                token: token,
                formData: {
                    id_venta: id,
                    tipoContratoActual: form.tipoContratoActual,
                    tipoServicio: form.tipoServicio,
                    contactabilidadValidaciones: form.contactabilidadValidaciones,
                    tematicoValidaciones: form.tematicoValidaciones,
                    numeroContactado: form.numeroContactado,
                    observacionBack: form.observacionBack,
                    origen: 'web'
                }
            });
            if (response.success) {
                toast.success(response.message);
                setLoading(false);
                setForm({
                    tipoContratoActual: "",
                    tipoServicio: "",
                    contactabilidadValidaciones: "",
                    tematicoValidaciones: "",
                    numeroContactado: "",
                    observacionBack: "",
                });
                fetchSeguimientoInstalado();
            } else {
                setError(response.message);
            }
        } catch (err) {
            setError("Error al registrar el seguimiento.");
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="ventas-admin-content">
            {loading && <Preloader />}
            <div className="breadcrumb-container">
                <span className="breadcrumb-link" onClick={handleBackToList}>
                    ← Listado de instaladas
                </span>
                <span className="breadcrumb-current"> / instaladas</span>
            </div>
            <div className=" nuevo-producto-card">
                <div className="flex justify-between gap-20">
                    <div className="w-70 ">
                        <span className="nueva-venta-instalada-title"> Registrar Seguimiento</span>
                        <div className="dashboard-card nueva-venta-responsive">
                            <form
                                className="nueva-venta-form"
                                onSubmit={handleSubmit}
                                autoComplete="off"
                            >
                                {error && <div className="error-message">{error}</div>}
                                {success && <div className="success-message">{success}</div>}

                                <div className="form-grid-3">
                                    <div className="">
                                        <Input title="Tipo de contrato Actual" value={form.tipoContratoActual} setValue={(val) => handleChange("tipoContratoActual", val)} placeholder="Ingrese" disable={onlyRead} required={true} />
                                        {errors.tipoContratoActual && <span className="error">{errors.tipoContratoActual}</span>}
                                    </div>
                                    <div className="">
                                        <Input title="Tipo de Servicio" value={form.tipoServicio} setValue={(val) => handleChange("tipoServicio", val)} placeholder="Ingrese" disable={onlyRead} required={true} />
                                        {errors.tipoServicio && <span className="error">{errors.tipoServicio}</span>}
                                    </div>
                                    <div className="">
                                        <Select title="Contactabilidad" value={form.contactabilidadValidaciones} setValue={(val) => handleChange("contactabilidadValidaciones", val)} options={[
                                            ...[
                                                {
                                                    id: 0,
                                                    nombre: 'Seleccione'
                                                }
                                            ],
                                            ...contactabilidadList
                                        ]} disable={onlyRead} required={true} />
                                        {errors.contactabilidadValidaciones && <span className="error">{errors.contactabilidadValidaciones}</span>}
                                    </div>
                                </div>

                                <div className="form-grid-columns">
                                    <div className="">
                                        <Select title="Temático Validaciones" value={form.tematicoValidaciones} setValue={(val) => handleChange("tematicoValidaciones", val)} options={[
                                            ...[
                                                {
                                                    id: 0,
                                                    nombre: 'Seleccione'
                                                }
                                            ],
                                            ...tematicList
                                        ]} disable={onlyRead} required={true} />
                                        {errors.tematicoValidaciones && <span className="error">{errors.tematicoValidaciones}</span>}
                                    </div>
                                    <div className="">
                                        <Input title="Num. contactado" value={form.numeroContactado} setValue={(val) => handleChange("numeroContactado", val)} placeholder="Ingrese" disable={onlyRead} required={true} />
                                        {errors.numeroContactado && <span className="error">{errors.numeroContactado}</span>}
                                    </div>
                                </div>

                                <div className="form-grid-2">
                                    <div className="">
                                        <Input title="Observación" value={form.observacionBack} setValue={(val) => handleChange("observacionBack", val)} placeholder="" type="textarea" disable={onlyRead} rows={6} required={true} />
                                        {errors.observacionBack && <span className="error">{errors.observacionBack}</span>}
                                    </div>
                                    <div className="">
                                        <button
                                            className="btn btn-primary w-full "
                                            type="submit"
                                            disabled={loading || onlyRead}
                                        >
                                            {loading
                                                ? "Procesando..."
                                                : "Registrar"
                                            }
                                        </button>
                                    </div>
                                </div>
                            </form>
                        </div>

                        <div className="ventas-table-wrapper pt-40">
                            <table className="ventas-table">
                                <thead>
                                    <tr>
                                        <th>F. Gestión</th>
                                        <th>Back</th>
                                        <th>Contactabilidad</th>
                                        <th>Temático</th>
                                        <th>Nro. Contactado</th>
                                        <th>Observación</th>
                                        <th># Contac</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {
                                        reportadas.map((r, k) => (
                                            <tr key={r.id}>
                                                <td>{new Date(r.fechaHoraSeguimiento).toLocaleDateString()}</td>
                                                <td>{r.usuario_nombre} {r.usuario_apellido_paterno} {r.usuario_apellido_materno}</td>
                                                <td>{r.contactabilidad}</td>
                                                <td>{r.tematico}</td>
                                                <td>{r.numeroContactado}</td>
                                                <td>{r.observacionBack}</td>
                                                <td>{r.item_correlativo}</td>
                                            </tr>
                                        ))
                                    }
                                </tbody>
                            </table>
                        </div>

                    </div>
                    <div className="w-30 bl-1">
                        {data ? (
                            <div className="container-gray">
                                <p>Asesor - {`${data?.venta?.nombre_vendedor || ''} ${data?.venta?.apellido_vendedor || ''}`}</p>
                                <p>SUPERVISOR - {data?.venta?.supervisor}</p>
                                <p>CÓDIGO CLIENTE - {data?.venta?.codigo_venta_cliente}</p>
                                <p>ESTADO - {data?.venta?.estado_cliente}</p>
                                <p>TIPO DOCUMENTO - {data?.cliente?.tipo_documento}</p>
                                <p>NÚMERO DOCUMENTO - {data?.cliente?.numero_documento}</p>
                                <p>NOMBRES COMPLETOS / RAZÓN SOCIAL</p>
                                <p>{`${data?.cliente?.cliente_razon_social} `}</p>
                                <p>TELÉFONO: {data?.cliente?.telefono_1}</p>
                                <p>TELÉFONO: {data?.cliente?.telefono_2}</p>
                                <p>TELÉFONO: {data?.cliente?.telefono_3}</p>
                            </div>
                        ) : (
                            <div className="container-gray">
                                <p>Cargando datos...</p>
                            </div>
                        )}
                    </div>

                </div>
            </div>
        </div>
    );
};

export default RegistrarWelcome;
